import React from "react";
import { Box, Typography } from "@mui/material";
import { BoxSpg, CheckboxFormField, GridContainer, GridItem } from "@duosoftbg/nacid-components";
import { useTranslation } from "react-i18next";

const ServiceSelectionSection = ({ isSubmittedOrFinalized }) => {
  const { t } = useTranslation();
  return (
    <BoxSpg
      component="fieldset"
      sx={{
        border: "1px solid #000",
        borderRadius: "4px",
        padding: 2,
        backgroundColor: "#fff",
        marginTop: "1em",
        "& legend": {
          padding: "0 8px",
          fontWeight: "bold",
          fontSize: "0.9rem",
        },
      }}
    >
      <Typography component="legend">Желая да получа</Typography>

      <Typography variant="body2" sx={{ mb: 0, fontStyle: "italic", color: "#059" }}>
        {t("m.service.selection.info")}
      </Typography>

      <BoxSpg pb={3}>
        <GridContainer spacing={4} mt={0}>
          <GridItem xs={12} sm={12} md={12}>
            <Box>
              <CheckboxFormField
                fieldName={"hasCertificate"}
                labelCode={"l.certificate.sec.education"}
                isDisabled={true}
              />
            </Box>
            <Typography fontSize={"12px"} fontStyle={"italic"} color={"#059"} marginLeft={"30px"}>
              {t("m.help.text.certificate.sec.education")}
            </Typography>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <Box>
              <CheckboxFormField
                fieldName={"hasOfficialNote"}
                labelCode={"l.official.note"}
                isDisabled={isSubmittedOrFinalized}
              />
            </Box>
            <Typography fontSize={"12px"} fontStyle={"italic"} color={"#059"} marginLeft={"30px"}>
              {t("m.help.text.official.note")}
            </Typography>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <Box>
              <CheckboxFormField
                fieldName={"hasVerificationLetter"}
                labelCode={"l.verification.letter"}
                isDisabled={isSubmittedOrFinalized}
              />
            </Box>
            <Typography fontSize={"12px"} fontStyle={"italic"} color={"#059"} marginLeft={"30px"}>
              {t("m.help.text.verification.letter")}
            </Typography>
          </GridItem>
        </GridContainer>
      </BoxSpg>
    </BoxSpg>
  );
};
export default ServiceSelectionSection;
